module.exports = __webpack_public_path__ + "static/img/areaA-30.8eb99a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/文字バージョン/areaA-30.png
// module id = 974
// module chunks = 1